// Package
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        label: {
            type: String,
            required: true,
            default: ""
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type: String,
            required: true,
            default: ""
        },
        errors: {
            type: Object,
            required: false,
            default: ()=>{},
        },
        value: {
            type: String,
            required: true,
            default: ""
        },
        col:{
            type: String,
            required: false,
            default: "12",
        },
        max:{
            type: String,
            required: false,
            default: "",
        },
        min:{
            type: String,
            required: false,
            default: "",
        },
        information:{
            type: String,
            required: false,
            default: null,
        },
        required:{
            type: Boolean,
            required: false,
            default: false,
        }
    }
})